/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { css } from 'styled-components';
import { useStores } from 'src/components/common/utils/useStore';
// Cpds
import { Cpds } from '@Cpds.Ui';

// Sub Components
import {
  V3CardTitle,
  V3CardIconLabelRow,
  V3CardIconLabelTextMedium,
  V3CardDescription,
  V3CardCtaContainer,
  V3CardIconLabelTextNormal,
} from '../styles/shared-style';

import { V3ProductCardPrice, V3ProuctCardPriceContainer } from '../styles/v3-product-card-variation-style';

//helpers
import { checkValue } from 'src/components/common/helper';

//typings
import { V3ProductCardVariationsComponentProps } from '../typings';
import { ClickStreamEventType, clickstreamDataJSON } from 'src/utils/event-wrapper';

const V3ProductCardVariations: React.FC<V3ProductCardVariationsComponentProps> = (props) => {
  const {
    exClasses = '',
    title,
    titleColor,
    location,
    description,
    mediaResponsive,
    aspectRatio,
    styleOverrides,
    imgsrc = 'https://cdn.sanity.io/images/nxpteyfv/media-studio/4eac2877cf1372bc2ccd04c48bdf8344d6cdc1a9-330x312.png?fit=max&w=250&h=250',
    cardWidth = '3_COLUMNS',
    cta,
    variation = 'VERTICAL',
    rating,
    price,
    date,
    priceMessage,
    imageSize = 'PROD_COMMERCIAL',
    clickstreamdata = clickstreamDataJSON(ClickStreamEventType.INTERACTION,'product_card','link.selected'),
    altText,
    ...rest
  } = props;

  const { sanityStore } = useStores();

  const generalBodyContent = () => (
    <>
      {/* {checkValue(paginationText) && <V3CardPagination>{paginationText}</V3CardPagination>} */}
      {checkValue(title) && (
        <V3CardTitle color={titleColor} size={`HOTEL_CARD_${cardWidth}`}>
          {title}
        </V3CardTitle>
      )}

      {checkValue(location) && (
        <V3CardIconLabelRow>
          <Cpds.Icon id="location-icon" name="pin" size="small" />
          <V3CardIconLabelTextMedium>{location}</V3CardIconLabelTextMedium>
        </V3CardIconLabelRow>
      )}

      {checkValue(rating?.rating) && (
        <Cpds.Ratings
          styleOverrides={css`
            margin-top: 8px;
          `}
          rating={rating?.rating}
          ratingText={rating?.ratingText}
          numberOfReviews={rating?.numberOfReviews}
        />
      )}
      {checkValue(price) && (
        <V3ProuctCardPriceContainer>
          <V3ProductCardPrice>{price}</V3ProductCardPrice>
          {(checkValue(date) || checkValue(priceMessage)) && (
            <V3CardIconLabelRow gap="2px" iconGap="4px">
              {checkValue(date) && (
                <>
                  <Cpds.Icon exClasses="product-card-calendar-icon" id="calendar-icon" name="calendar" size="small" />
                  <V3CardIconLabelTextMedium>{date}</V3CardIconLabelTextMedium>
                </>
              )}
              {checkValue(priceMessage) && <V3CardIconLabelTextNormal>{priceMessage}</V3CardIconLabelTextNormal>}
            </V3CardIconLabelRow>
          )}
        </V3ProuctCardPriceContainer>
      )}
      {checkValue(description) && <V3CardDescription marginTop="12px">{description}</V3CardDescription>}
      {!variation.includes('HORIZONTAL') && checkValue(cta?.text) && checkValue(cta?.url) && (
        <V3CardCtaContainer
          ctaColor={cta?.ctaColor}
          styleOverrides={css`
            margin-top: 12px;
          `}
        >
          <Cpds.Button
            exClasses="v3-destination-card-button"
            buttonType="Tertiary"
            tag="a"
            href={cta?.url}
            buttonSize={'small'}
            target={cta.target || '_self'}
            {...(clickstreamdata ? {
              "data-isclickstreamenabled": true,
              "data-clickstreamdata": clickstreamdata
            } : {})}
          >
            {cta?.text}
            {checkValue(cta?.icon) && <Cpds.Icon id={'key-2'} name={cta?.icon} size="small" />}
          </Cpds.Button>
        </V3CardCtaContainer>
      )}
    </>
  );

  const fixtureBodyContent = () => (
    <>
      {checkValue(title) && (
        <V3CardTitle color={titleColor} size={`HOTEL_CARD_${cardWidth}`}>
          {title}
        </V3CardTitle>
      )}
      {checkValue(date) && (
        <V3CardIconLabelRow gap="2px" iconGap="4px">
          {checkValue(date) && (
            <>
              <Cpds.Icon exClasses="product-card-calendar-icon" id="calendar-icon" name="calendar" size="small" />
              <V3CardIconLabelTextMedium>{date}</V3CardIconLabelTextMedium>
            </>
          )}
        </V3CardIconLabelRow>
      )}
    </>
  );

  const generalActionContent = () => (
    <V3CardCtaContainer ctaColor={cta?.ctaColor} flexDirection={'row'} align={'center'}>
      <Cpds.Button
        exClasses="v3-article-horizontal-card-button"
        buttonType="Tertiary"
        tag="a"
        href={cta?.url}
        buttonSize={'small'}
        target={cta.target || '_self'}
        {...(clickstreamdata ? {
          "data-isclickstreamenabled": true,
          "data-clickstreamdata": clickstreamdata
        } : {})}
      >
        {cta?.text}
        {!checkValue(cta.icon) && <Cpds.Icon id={'product-horizontal-card'} name="chevron-right" size="extra_small" />}
      </Cpds.Button>
      {checkValue(cta.icon) && (
        <Cpds.Image
          src={cta.icon}
          styleOverrides={css`
            width: 10px !important;
            height: 9px !important;
          `}
        />
      )}
    </V3CardCtaContainer>
  );

  const fixtureActionContent = () => (
    <V3CardCtaContainer ctaColor={cta?.ctaColor} align="flex-end">
      {checkValue(price) && <V3ProductCardPrice size="fixture">{price}</V3ProductCardPrice>}
      {checkValue(priceMessage) && <V3CardIconLabelTextNormal>{priceMessage}</V3CardIconLabelTextNormal>}
      <Cpds.Button
        styleOverrides={css`
          margin-top: 4px;
        `}
        exClasses="v3-article-horizontal-card-button"
        buttonType="Tertiary"
        tag="a"
        href={cta?.url}
        buttonSize={'small'}
        target={cta.target || '_self'}
        {...(clickstreamdata ? {
          "data-isclickstreamenabled": true,
          "data-clickstreamdata": clickstreamdata
        } : {})}
      >
        {cta?.text}
        {checkValue(cta?.icon) && <Cpds.Icon id={'key-2'} name={cta?.icon} size="small" />}
      </Cpds.Button>
    </V3CardCtaContainer>
  );

  const onCardClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (cta?.url) {
      window.open(
        cta?.url,
        cta?.target || '_self',
      );
    }
  };

  return (
    <Cpds.Card.Card
      styleOverrides={styleOverrides}
      exClasses={`${exClasses} v3-destination-card`}
      cardWidth={cardWidth}
      variation={variation}
      imageSize={cardWidth === 'HORIZONTAL_PRODUCT_FIXTURE' ? 'PROD_FIXTURE' : imageSize}
      noLeftBorder={true}
      cta={cta}
      {...rest}
      onClick={onCardClick}
    >
      <Cpds.Card.CardMedia aspectRatio={aspectRatio} altText={altText} imgsrc={imgsrc} responsive={mediaResponsive} />

      <Cpds.Card.CardContent
        styleOverrides={css`
          gap: 4px !important;
        `}
      >
        {cardWidth === 'HORIZONTAL_PRODUCT_FIXTURE' ? fixtureBodyContent() : generalBodyContent()}
      </Cpds.Card.CardContent>
      {variation.includes('HORIZONTAL') && checkValue(cta?.text) && checkValue(cta?.url) && (
        <Cpds.Card.CardAction actionDivWidth={'98px'}>
          {cardWidth === 'HORIZONTAL_PRODUCT_FIXTURE' ? fixtureActionContent() : generalActionContent()}
        </Cpds.Card.CardAction>
      )}
    </Cpds.Card.Card>
  );
};

export default V3ProductCardVariations;
